const getPreferences = async (accessToken, globoid, scope,) => {
  if (!accessToken) {
    throw new Error('invalid accessToken')
  }

  // eslint-disable-next-line no-undef
  const urlString = `${WEB_BFF_URL}/v1/preferences/scopes/${scope}`

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  }

  const requestOptions = {
    method: 'GET',
    headers,
    credentials: 'include',
    timeout: 5000,
  }

  const response = await fetch(urlString, requestOptions)

  if (!response.ok) {
    throw new Error(`[PreferencesAPI.js] API error: ${response.status}`)
  }

  return await response.json()
}

const updatePreferences = async (accessToken, scope, attributes) => {
  if (!accessToken) {
    throw new Error('invalid accessToken')
  }

  // eslint-disable-next-line no-undef
  const urlString = `${WEB_BFF_URL}/v1/preferences/scopes/${scope}`

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`
  }

  const requestOptions = {
    method: 'PUT',
    headers,
    credentials: 'include',
    body: JSON.stringify(attributes),
    timeout: 5000,
  }

  return await fetch(urlString, requestOptions)
    .then(res => {
      if (!res.ok) {
        throw new Error('[PreferencesAPI.js] API error: ' + res.status)
      }
    })
    .catch(err => { throw new Error(`[PreferencesAPI.js] ${err.message}`) })
}

const deletePreferences = async (accessToken, scope, key) => {
  if (!accessToken) {
    throw new Error('invalid accessToken')
  }
  // eslint-disable-next-line no-undef
  const url = `${WEB_BFF_URL}/v1/preferences/scopes/${scope}/key/${key}`

  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Authorization', 'Bearer ' + accessToken)

  const requestOptions = {
    method: 'DELETE',
    headers,
    credentials: 'include',
    timeout: 5000,
  }

  return await fetch(url, requestOptions)
    .then(res => {
      if (!res.ok) {
        throw new Error('[PreferencesAPI.js] API error: ' + res.status)
      }
    })
    .catch(err => { throw new Error(`[PreferencesAPI.js] ${err.message}`) })
}

export { getPreferences, updatePreferences, deletePreferences }